<template>
  <div class="modal" :class="{ 'closed': !isOpen }">
    <div class="modal-backdrop" @click="close"></div>
    <div class="modal-container" :class="{ 'closed': !isOpen }">
      <!-- <button class="close-button" @click="close">X</button> -->
      <h2>{{ header }}</h2>
      <img :src="imageUrl" alt="Modal Image" />
      <p>{{ paragraph }}</p>
      <button class="begin" @click="close">Begin</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    header: {
      type: String,
      default: "Modal Header"
    },
    imageUrl: {
      type: String,
      default: ""
    },
    paragraph: {
      type: String,
      default: "Modal paragraph text."
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Arial, Helvetica, sans-serif;
  transition: opacity 0.3s 0.3s;
  opacity: 1;
}

.modal-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  cursor: pointer;
}

.modal-container {
  background-color: white;
  padding: 20px;
  text-align: center;
  position: relative;
  z-index: 800;
  width: 70%;
  transition: opacity 0.3s, transform 0.3s;
  opacity: 1;
  transform: scale(1);
}

.modal-container.closed {
  opacity: 0;
  transform: scale(0.8);
  pointer-events: none;
}

.modal.closed {
  opacity: 0;
  pointer-events: none;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 5px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: rgb(0, 0, 0, 0.25);
}

h2 {
  font-size: 24px;
  margin-bottom: 20px;
  margin-top: 0;
}

img {
  width: 100%;
  height: auto;
  margin-bottom: 10px;
}

p {
  font-size: 16px;
  margin-bottom: 20px;
  text-align: left;
}


.begin{
  background: linear-gradient(-90deg, rgba(241,201,119,1) 0%, rgba(249,230,175,1) 100%);
  color: rgba(26,46,87,1);
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 3.2px;
  line-height: 1.250em;
  padding: 2.5rem 5.1rem;
  display: inline-block;
  text-transform: uppercase;
  position: relative;
  overflow: hidden;
  z-index: 1;
  border: none;
  padding: 1.5rem 2.5rem;
  text-decoration: none;
  font-family: Arial, Helvetica, sans-serif;
}

</style>
